<template>
<div  class="achievementTypeeidt">
     <div class="header">    
        <el-button size="medium" type="default" @click.native="$router.back()">返回</el-button>  
        <el-button type="primary" size="medium"  @click="submitForm('ruleForm')">保存</el-button>
     </div>
     <div class="subject" :style="`height: ${windowHeight - 180}px;`">
         <div class="body">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">  
                <el-form-item label="学段" prop="schoolType">
                  <el-select v-model="ruleForm.schoolType" placeholder="请选择学段"  :disabled="true" @change="getCurrBySchoolTypes()">
                    <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in schoolTypelist"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学科" prop="currId" >
                  <el-select v-model="ruleForm.currId" placeholder="请选择学科" :disabled="true">
                    <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in currlist"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="题型" prop="checkboxlist">
                  <el-checkbox-group v-model="ruleForm.checkboxlist">
                    <el-checkbox :label="item.id" :key="item.id" v-for="item in subjectlist" >{{item.value}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
         </div>
     </div>
</div> 
</template>
<script>
import {getCurrBySchoolType,findDicsByCode,editCurrQuestion,currQuestionDetails} from "@/api/achievement";
import windowResize from "@/mixins/windowResize";
export default {
  name: "dataAnalysis",
  data() {
    return {
      schoolTypelist: [
        // { name: "幼儿园", id: 1 },
        { name: "小学", id: 2 },
        { name: "初中", id: 3 },
        { name: "高中", id: 4 },
        // { name: "六年制", id: 6 },
        // { name: "九年制", id: 9 },
        // { name: "十二年制", id: 12 },
        // { name: "特殊学校", id: 10 }
      ],
      subjectlist:[],
      currlist: [],
      ruleForm:{
        currId:'',//	科目id	number	
        currName:'',//	科目名称	string	
        relationJson:[],//	题型	array<>	
        schoolType:2,//	学校类型	number	
        schoolTypeName:'',//	学校类型名称	string	
        checkboxlist:[],
        id:this.$route.query.id
      },
       rules: {
          currId: [
            { required: true, message: '请选择学科', trigger: 'change' }
          ],
          schoolType: [
            { required: true, message: '请选择学段', trigger: 'change' }
          ],
          checkboxlist: [
            { type: 'array', required: true, message: '请至少选择一个题型', trigger: 'change' }
          ],
        }
    };
  },
  mixins: [windowResize],
  created() {
      currQuestionDetails(this.$route.query.id)
        .then(res => res.data)
        .then(data => {
          console.log(data)
          this.ruleForm.currId=data.data.currId;
          this.ruleForm.schoolType=data.data.schoolType;
          for(let i=0;i<data.data.relationList.length;i++){
              this.ruleForm.checkboxlist.push(data.data.relationList[i].queTypeId)
          }
          this.getCurrBySchoolTypes();
          this.findDicsByCodes();
        });
      
  },
  methods: {
  findDicsByCodes(){
    findDicsByCode()
        .then(res => res.data)
        .then(data => {
          this.subjectlist=data.data;
        });
  },
  getCurrBySchoolTypes() {
      this.currlist=[];
      getCurrBySchoolType(this.ruleForm.schoolType)
        .then(res => res.data)
        .then(data => {
           for(let i=0;i<data.length;i++){
            if(data[i].examType==1){
               this.currlist.push(data[i])
            }
          }
        });
    },
   submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            for(let i=0;i<this.currlist.length;i++){
              if(this.currlist[i].id==this.ruleForm.currId){
                 this.ruleForm.currName=this.currlist[i].name;
              }
            }
            for(let i=0;i<this.schoolTypelist.length;i++){
              if(this.schoolTypelist[i].id==this.ruleForm.schoolType){
                 this.ruleForm.schoolTypeName=this.schoolTypelist[i].name;
              }
            }
            let list=[]
            for(let i=0;i<this.ruleForm.checkboxlist.length;i++){
              for(let j=0;j<this.subjectlist.length;j++){
                if(this.ruleForm.checkboxlist[i]==this.subjectlist[j].id){
                  list.push({
                    queTypeId:this.ruleForm.checkboxlist[i],
                    queTypeName:this.subjectlist[j].value
                  })
                }
              }
            } 
            this.ruleForm.relationJson=JSON.stringify(list);
             editCurrQuestion(this.ruleForm).then(res => {
                      if (res.data.code === 200) {
                            this.$message({
                                            type: 'success',
                                            message: '编辑成功!'
                                        });
                            this.$router.back()
                        }                    
                    }).catch(err=>{
                    });
          } 
        });
      },  
  }
};
</script>
<style>
  .achievementTypeeidt .el-checkbox{
    margin-right: 10px;
  }
</style>
<style lang="scss" scoped>
.achievementTypeeidt {
  padding: 12px;
  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid  #eee;
  }
  .subject{
      overflow: auto;
      .body{
          width: 810px;
          margin: 10px auto;
          .el-select{
           width: 100%;
          }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/achievement/achievementTypeeidt.vue